export class TransformedUrl {
  private static readonly SquareNamedTransformationName = 't_pdpHeroGallery';

  private _transformations: Transformation[];

  constructor(private _url: string) {
    this._transformations = [];
  }

  public stack(transformation: Transformation): void {
    this._transformations.push(transformation);
  }

  toString(): string {
    if (!this._url.includes(TransformedUrl.SquareNamedTransformationName)) {
      return this._url;
    }

    const transformationsPart = this._transformations
      .map((transformation) => transformation.toString())
      .join('/');

    return this._url.replace(/[^/]*t_pdpHeroGallery_[^/]+/, transformationsPart);
  }
}

export abstract class Transformation {
  protected _transformations: string[];

  constructor(...transformations: string[]) {
    this._transformations = transformations;
  }

  abstract toString(): string;
}

export abstract class DirectTransformation extends Transformation {
  constructor(...transformations: string[]) {
    super(...transformations);
  }

  toString(): string {
    return this._transformations.join(',');
  }
}

export abstract class ConditionalTransformation extends Transformation {
  private static readonly EndCondition = 'if_end';
  private static readonly ElseCondition = 'if_else';

  private _includedTransformations: Transformations;
  private _includedElseTransformations: Transformations;

  constructor(...conditions: string[]) {
    super(...conditions);

    this._includedTransformations = new Transformations();
    this._includedElseTransformations = new Transformations();
  }

  include(transformation: Transformation): void {
    this._includedTransformations.add(transformation);
  }

  includeElse(transformation: Transformation): void {
    this._includedElseTransformations.add(transformation);
  }

  toString(): string {
    const joinedConditions = this._transformations.join('_and_');
    const condition = `if_${joinedConditions}`;

    if (this._includedElseTransformations.empty) {
      return [
        condition,
        this._includedTransformations.toString(),
        ConditionalTransformation.EndCondition,
      ].join('/');
    }

    return [
      condition,
      this._includedTransformations.toString(),
      ConditionalTransformation.ElseCondition,
      this._includedElseTransformations.toString(),
      ConditionalTransformation.EndCondition,
    ].join('/');
  }
}

class Transformations {
  private _transformations: Transformation[];

  constructor() {
    this._transformations = [];
  }

  get empty(): boolean {
    return this._transformations.length === 0;
  }

  add(transformation: Transformation): void {
    this._transformations.push(transformation);
  }

  toString(): string {
    return this._transformations.map((transformation) => transformation.toString()).join(',');
  }
}
